import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './components/button/button.component';
import { StepperComponent } from './stepper/stepper.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { CustomInputComponent } from './components/custom-input/custom-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';
import { FootnoteComponent } from './footnote/footnote.component';
import { RequirementsModalComponent } from './components/requirements-modal/requirements-modal.component';
import { FirstInformationLayerComponent } from './components/first-information-layer/first-information-layer.component';

@NgModule({
  declarations: [
    ButtonComponent,
    StepperComponent,
    CustomDropdownComponent,
    CustomInputComponent,
    BackButtonComponent,
    CheckoutComponent,
    SpinnerComponent,
    FootnoteComponent,
    RequirementsModalComponent,
    FirstInformationLayerComponent
  ],
  exports: [
    ButtonComponent,
    StepperComponent,
    CustomDropdownComponent,
    CustomInputComponent,
    BackButtonComponent,
    ConfirmDialogComponent,
    SpinnerComponent,
    TranslateModule,
    FootnoteComponent,
    FirstInformationLayerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ConfirmDialogComponent,
    MatDialogModule,
    TranslateModule
  ]
})
export class SharedModule { }
